import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StandingOrderHistoryComponent } from './standing-order-history.component';
import {AgGridModule} from 'ag-grid-angular';
import {Trip2ThemeModule} from '../../../trip2-theme/trip2-theme.module';
import {FormsModule} from '@angular/forms';
import {CancelStatusModule} from '../cancel-status/cancel-status.module';
import { MyDateRangePickerModule } from 'mydaterangepicker';
import { DateRangeAvailableUpdateSoModule } from 'app/utils/date-range-available-update-so/date-range-available-update-so.module';

@NgModule({
  imports: [
    CommonModule,
    AgGridModule.withComponents([]),
    FormsModule,
    Trip2ThemeModule,
    CancelStatusModule,
    MyDateRangePickerModule,
    DateRangeAvailableUpdateSoModule
  ],
  declarations: [StandingOrderHistoryComponent],
  exports: [
    StandingOrderHistoryComponent
  ]
})
export class StandingOrderHistoryModule { }



// WEBPACK FOOTER //
// ./src/app/pages/trip-reservations/standing-order-history/standing-order-history.module.ts